import { message } from '../../../utils/common';
import { BoxProps, HtmlParser } from '../../atoms';

type MessageProps = {
  text: unknown;
  fallback: string;
  variables?: Record<string, string | number>;
  asSpan?: boolean;
};

export function Message({
  text,
  fallback,
  variables,
  asSpan = true,
  ...rest
}: MessageProps & BoxProps): JSX.Element {
  return (
    <HtmlParser
      asSpan={asSpan}
      html={message(text, fallback, variables)}
      {...rest}
    />
  );
}
